<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { SIGNUP_URL } from "@/seo/config";

const { t } = useI18n();
</script>

<template>
  <section data-reveal class="fade-in bg-[var(--color-primary)] px-5 py-12 md:px-12 md:py-20">
    <div class="mx-auto max-w-[640px] text-center">
      <h2
        class="text-2xl font-semibold text-white md:text-4xl"
        style="font-family: var(--font-display)"
      >
        {{ t("finalCta.heading") }}
      </h2>
      <p class="mt-4 text-lg text-white/80">
        {{ t("finalCta.subheading") }}
      </p>
      <a
        :href="SIGNUP_URL"
        class="mt-7 inline-block w-full rounded-full bg-white px-8 py-3.5 text-center text-base font-semibold text-[var(--color-primary)] transition-colors hover:bg-white/90 md:w-auto"
      >
        {{ t("finalCta.cta") }}
      </a>
    </div>
  </section>
</template>
